import React from 'react';

/**
 * A titled section on a profile page. Sections after the first get a divider above them.
 * @param {{ title: string, children: React.ReactNode }} props
 */
const ProfileSection = ({ title, children }) => (
    <section className="flex flex-col gap-4 border-b border-border py-5 last:border-b-0">
        <h3 className="text-xl font-bold text-foreground/80">{title}</h3>
        <div className="flex min-w-0 flex-col gap-4 px-4">{children}</div>
    </section>
);

export default ProfileSection;
